export enum SubmissionStatus {
    NOT_SUBMITTED = "NOT_SUBMITTED", GRADED = "GRADED", NOT_GRADED = "NOT_GRADED", PUBLISHED = "PUBLISHED"
}
